import React from "react";
import { Calendar, InputText, Label } from "../../../components/Inputs";
import { toDBDate } from "../../../components/Utils";
import { SearchIconButton } from "../../../components/Buttons";

import { connect } from "react-redux";
import { searchNewsArchives } from "../actions";

const mapDispatchToProps = (dispatch) => ({
  searchArchives: (...args) => dispatch(searchNewsArchives(...args)),
});

function NewsArchiveSearchPanel({
  className = "",
  rowClassName = "",
  cellClassName = "",
  mini,
  searchArchives,
}) {
  const [state, setState] = React.useState({
    keyword: "",
    fromDate: "",
    toDate: "",
    error: null,
  });

  const getValidState = (st) => {
    const { error, ...rest } = st;
    const tokens = [];
    Object.keys(rest).forEach((key) => {
      if (rest[key] && (rest[key] instanceof Date || rest[key].length > 0)) {
        tokens.push(key);
      }
    });
    return tokens;
  };
  const onSearch = () => {
    const { error, ...rest } = state;
    const tokens = getValidState(state);
    // ensure that atleast one value is given
    const filter = {
      ...rest,
      fromDate: toDBDate(rest.fromDate),
      toDate: toDBDate(rest.toDate),
      id: Math.random(),
    };
    const query = tokens
      .map((key) => `${key}=${encodeURIComponent(filter[key])}`)
      .join("&");
    searchArchives({ filter, query, sortFields: {} });
  };
  const onChange = (key, value) => {
    setState((prev) => ({ ...prev, [key]: value, error: null }));
  };

  const { keyword, fromDate, toDate, error } = state;
  const keywordLabel = "Suche (Inhalt und Betreff)";
  const fromLabel = "Datum von";
  const toLabel = "Datum bis";
  const inputClassName = `w3-block w3-border ${error ? "w3-border-red" : ""}`;
  return (
    <div className={`news-archive-search-panel ${className}`}>
      <div className={`${rowClassName}`}>
        <div className={`w3-cell-row`}>
          <div className="w3-cell w3-cell-middle">
            <div className={cellClassName}>
              <Label htmlFor="keyword" className={mini ? "w3-hide" : ""}>
                {keywordLabel}
              </Label>
              <InputText
                id="keyword"
                className={inputClassName}
                value={keyword}
                onChange={(event) => onChange("keyword", event.target.value)}
                onKeyUp={(event) => event.keyCode === 13 && onSearch()}
                placeholder={mini ? keywordLabel : ""}
              />
            </div>
          </div>
          <div className="w3-cell w3-cell-middle" style={{ width: "12em" }}>
            <div className={cellClassName}>
              <Label htmlFor="fromDate" className={mini ? "w3-hide" : ""}>
                {fromLabel}
              </Label>
              <Calendar
                id="fromDate"
                className={inputClassName}
                value={fromDate}
                readOnlyInput={true}
                dateFormat="dd.mm.yy"
                maxDate={new Date()}
                onChange={(event) => onChange("fromDate", event.value)}
                showButtonBar
                placeholder={mini ? toLabel : "TT.MM.JJJJ"}
              />
            </div>
          </div>
          <div className="w3-cell w3-cell-middle" style={{ width: "12em" }}>
            <div className={cellClassName}>
              <Label htmlFor="toDate" className={mini ? "w3-hide" : ""}>
                {toLabel}
              </Label>
              <Calendar
                id="toDate"
                className={inputClassName}
                value={toDate}
                readOnlyInput={true}
                dateFormat="dd.mm.yy"
                maxDate={new Date()}
                onChange={(event) => onChange("toDate", event.value)}
                showButtonBar
                placeholder={mini ? toLabel : "TT.MM.JJJJ"}
              />
            </div>
          </div>
          <div className="w3-cell w3-cell-middle" style={{ width: "2.75em" }}>
            <div className={cellClassName}>
              <Label className={mini ? "w3-hide" : "text-trans"}>S</Label>
              <SearchIconButton
                className="w3-border"
                onClick={() => onSearch()}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default connect(null, mapDispatchToProps)(NewsArchiveSearchPanel);
